The success result for the `createCandidateProcessHistoryItem` mutation.
